<template>
    <md-dialog
        id="change-payment-method-dialog"
        :md-active="open"
        :class="{
            open: open,
        }"
        @md-opened="onOpen"
        @md-closed="close"
    >
        <div id="change-payment-method-container">
            <button type="button" class="close" @click="close">
                <md-icon class="md-size-2x">close</md-icon>
            </button>
            <md-dialog-title>
                <div class="md-display-1">
                    <template v-if="user.card"> Update Credit Card </template>
                    <template v-else> Add Credit Card </template>
                </div>
                <div :class="{ error: true, hidden: !errorMessage }">
                    {{ errorMessage }}
                </div>
                <div v-if="message">
                    <md-icon class="md-size-2x pm-icon">announcement</md-icon>
                    <div class="pm-message">
                        {{ message }}
                    </div>
                </div>
            </md-dialog-title>
            <div class="spinner md-layout md-alignment-center-center">
                <md-progress-spinner v-show="sending" md-mode="indeterminate" />
            </div>
            <div class="fields" :class="{ hidden: sending }">
                <PaymentForm
                    ref="paymentRef"
                    type="setup"
                    :force-new-payment-method="true"
                    captcha-action="createSetupIntent"
                    @confirmed="onSetupConfirmed"
                    @confirming="onConfirming"
                    @complete="onPaymentFormComplete"
                    @loading="onPaymentFormLoading"
                />
            </div>

            <md-dialog-actions>
                <md-button
                    type="button"
                    class="md-primary md-raised"
                    :disabled="submitDisabled"
                    @click="submit"
                >
                    <template v-if="user.card"> Update </template>
                    <template v-else> Add </template>
                </md-button>
            </md-dialog-actions>

            <div class="captcha-terms md-caption">
                This site is protected by reCAPTCHA and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a>
                and
                <a href="https://policies.google.com/terms">Terms of Service</a>
                apply.
            </div>
        </div>
        <!-- end form container -->
    </md-dialog>
</template>

<script>
import PaymentForm from './PaymentForm.vue';

export default {
    name: 'ChangePaymentMethodDialog',
    components: {
        PaymentForm,
    },
    props: {
        open: {
            type: Boolean,
            required: false,
            default: () => false,
        },
        message: {
            type: String,
            required: false,
            default: () => '',
        },
    },
    data: () => ({
        sending: false,
        errorMessage: '',
        paymentFormReady: false,
        paymentFormLoading: true,
        user: {},
        cardComplete: false,
    }),
    computed: {
        submitDisabled: function () {
            return (
                this.sending || this.paymentFormLoading
                //|| !this.paymentFormReady //remove this because it does not work correctly on android devices
            );
        },
    },
    async created() {
        this.user = (await this.$gideo.getUserInfo()) || {};
        const setUser = async () => {
            this.user = (await this.$gideo.getUserInfo()) || {};
        };
        this.$gideo.bus.$on('logged-in', setUser);
        this.$gideo.bus.$on('logged-out', setUser);
    },
    methods: {
        reset() {
            this.errorMessage = undefined;
            this.sending = false;
            this.paymentFormReady = false;
            this.$refs?.paymentRef?.reset();
        },
        onOpen() {
            this.reset();
            this.$refs.paymentRef.focus();
        },
        onPaymentFormComplete(ready) {
            this.paymentFormReady = ready;
        },
        onPaymentFormLoading(loading) {
            this.paymentFormLoading = loading;
        },
        onSetupConfirmed() {
            this.$emit('saved', true);
            this.close();
            this.reset();
        },
        onConfirming(isSending) {
            this.sending = isSending;
            if (isSending) {
                this.errorMessage = undefined;
            }
        },
        submit() {
            this.$refs.paymentRef.submit();
        },
        close() {
            this.$emit('update:open', false);
        },
    },
};
</script>

<style lang="scss">
#change-payment-method-dialog {
    .md-dialog-container {
        max-width: 100%;
        padding: 1rem 4rem;
        color: #333;
        background-color: #fff;
        font-size: 1.1rem;
        line-height: 1.1em;
        z-index: 1001;
        border: 0.125rem solid #fff;
        overflow: auto;
        position: relative;

        @media (min-width: 600px) {
            max-width: 90%;
        }
        @media (min-width: 1080px) {
            font-size: 1.3rem;
            min-width: 40%;
            max-width: 65%;
        }

        .md-dialog-title {
            text-align: center;
            font-size: 2.2em;
        }
        .md-dialog-actions {
            flex-direction: column;
            justify-content: center;
            .btn {
                margin: 0.5em;
            }

            @media (min-width: 600px) {
                flex-direction: row;
            }
        }
        .dialog-background {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            z-index: -1;
            background-repeat: no-repeat;
            background-size: cover;
        }
    }
}
body .md-menu-content.md-select-menu {
    z-index: 1120;
}
</style>
<style scoped lang="scss">
@import '@/assets/css/_variables.scss';

#change-payment-method-dialog {
    z-index: 1110;

    .error {
        padding: 1em;
        color: #ff1744;
        line-height: 1.1em;
        min-height: 3.1em;
        font-size: 12px;
        transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    }
    .hidden {
        opacity: 0;
        z-index: -1;
    }
    .spinner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .pm-message {
        font-size: 0.45em;
        max-width: 40em;
        text-align: center;
        margin: auto;
        color: #ff1744;
    }
    .pm-icon {
        color: #ff1744;
    }
    .fields {
        transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    }
    .close {
        padding: 0;
        background: transparent;
        border: none;
        width: 3.8rem;
        height: 3.8rem;
        transition:
            transform 0.3s ease 0.2s,
            opacity 0.3s ease 0.2s;
        transform: scale(0);
        cursor: pointer;
        position: absolute;
        top: 1rem;
        right: 1rem;

        &:hover {
            opacity: 0.7;
        }

        .md-icon {
            color: #333;
            width: 3.8rem;
            height: 3.8rem;
            min-width: 3.8rem;
            font-size: 3.8rem !important;
        }
    }
    &.open .close {
        transform: scale(1);
    }
}
</style>
